<template>
  <vue-resize-sensor class="container" @resize="onResize">
    <router-view />
  </vue-resize-sensor>
</template>

<script>
import VueResizeSensor from '@seregpie/vue-resize-sensor';
export default {
  name: 'App',
  components: { VueResizeSensor },
  methods: {
    onResize(size) {
      let path = this.$route.path;
      let info = this.$utils.getBrowserInfo();
      let newPath = undefined;
      if (info.mobile) {
        if (path.indexOf('/app') === 0) {
          return;
        }
        if (path.indexOf('/detail') === 0) {
          newPath = path.replace('/detail', '/app_detail');
        } else {
          newPath = `/app${path}`;
        }
      } else {
        if (path.indexOf('/app_detail') === 0) {
          newPath = path.replace('/app_detail', '/detail');
        } else if (path.indexOf('/app') === 0) {
          newPath = path.replace('/app', '');
        }
      }
      if (typeof newPath === 'undefined' || path === newPath) {
        return;
      }
      this.$router.replace({
        path: newPath,
        query: this.$route.query,
        params: this.$route.params,
      });
    },
  },
}
</script>

<style lang="scss">
#app {
  zoom: 1;
  -moz-transform: scale(1);
  -moz-transform-origin: 0 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.container {
  width: 100%;
  height: 100%;
}
</style>
